import { useAuthentication } from '@givebacks/api';
import { useQuery } from '@tanstack/react-query';
import { useCoreApi } from 'core/Api';

import { IUserCard } from '../../../types/user';

function useListUserPaymentMethods(select: any = undefined) {
  const { isAuthenticated } = useAuthentication();
  const CoreApi = useCoreApi();

  const getPaymentMethods = async () => {
    const { data } = await CoreApi.get(`/payment_methods`);
    return data.credentials;
  };

  return useQuery({
    queryKey: ['user', 'payment_methods'],
    queryFn: getPaymentMethods,
    placeholderData: [],
    select,
    enabled: isAuthenticated,
  });
}

export function useSelectHasEitherCardTypes() {
  return useListUserPaymentMethods((credentials: IUserCard[]) =>
    credentials.some((credential) => credential.rewards_network || credential.rakuten)
  );
}
